<template>
	<modal ref="modal" size="modal-lg">
		<template #title>{{emailSwipe.title??''}}</template>
		<template #body>
			<div class="mb-5" style="white-space: pre; white-space:break-spaces;">
				{{emailSwipe.email_format.replaceAll("<br/>","\n")}}
			</div>
		</template>
		<template #footer>
			<button @click="toggleModal" type="button" class="btn btn-alt-secondary">
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { ref } from 'vue';

export default {
	props: {
		emailSwipe: Object
	},
	setup(props) {
		const modal = ref(null);
		
		const toggleModal = () => {
			modal.value.toggleModal()
		}

		return {
			modal,
			toggleModal,
		}
	},
}
</script>
